export default function WhoWeServe() {
  const clients = [
    {
      title: 'Property Managers & Landlords',
      items: [
        'Pre-1978 rental property compliance',
        'Tenant turnover inspections',
        'Portfolio-wide assessments',
        'Ongoing compliance support',
      ],
      icon: 'ri-building-2-line',
    },
    {
      title: 'Public Housing Authorities',
      items: [
        'HUD compliance programs',
        'Large-scale unit inspections',
        'Grant-funded projects',
        'Regulatory documentation',
      ],
      icon: 'ri-government-line',
    },
    {
      title: 'Schools & Childcare Facilities',
      items: [
        'AHERA compliance',
        'Safe learning environments',
        'Periodic re-inspections',
        'Emergency response planning',
      ],
      icon: 'ri-school-line',
    },
    {
      title: 'Developers & Builders',
      items: [
        'Pre-renovation assessments',
        'Abatement design services',
        'Contractor bid management',
        'Project oversight',
      ],
      icon: 'ri-hammer-line',
    },
  ];

  return (
    <section id="who-we-serve" className="py-12 sm:py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-black mb-3 sm:mb-4">Who We Serve</h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            We provide specialized environmental consulting services to a diverse range of clients across multiple sectors.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
          {clients.map((client, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 sm:p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-[#f59e0b] text-white rounded-lg mb-3 sm:mb-4">
                <i className={`${client.icon} text-xl sm:text-2xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-black mb-3 sm:mb-4">{client.title}</h3>
              <ul className="space-y-2 sm:space-y-3">
                {client.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <div className="flex items-center justify-center w-5 h-5 bg-[#f59e0b] text-white rounded-full mr-2 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-xs"></i>
                    </div>
                    <span className="text-sm text-gray-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
